import { request } from '@/lib/request';

export async function fetchLogout(): Promise<boolean> {
  await request.post('/auth/logout');

  return true;
}
